import React from "react"

import { Row, Col, Button } from "react-bootstrap"

const EmailCapture = () => {
  return (
    <Row className="justify-content-md-center">
      <Col sm='7' className='text-center mt-5'>
        <h2>Still having trouble understanding or calculating your SaaS metrics?</h2>
        <p className='mt-4'>
          <Button variant='primary' href='mailto:alex@getprobe.io'>Get in touch</Button><Button variant='link' href='https://calendly.com/alex-getprobe-io/30min'>or setup 30 min call with us</Button>
        </p>
      </Col>
    </Row>
  )
}

export default EmailCapture
